// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2_GpK","name":"Header_name__yajJm","birthday":"Header_birthday__3g78z","skeleton":"Header_skeleton__3FkAX"};